export const testimonials = [
  {
    id: 1,
    name: 'Sarah Johnson',
    role: 'CTO',
    company: 'TechCorp',
    avatar: 'https://i.pravatar.cc/150?img=1',
    quote: 'Working with Shehan was a game-changer for our project. His technical expertise and problem-solving skills are exceptional.',
  },
  {
    id: 2,
    name: 'Michael Chen',
    role: 'Product Manager',
    company: 'InnovateLabs',
    avatar: 'https://i.pravatar.cc/150?img=13',
    quote: 'Shehan delivered our e-commerce platform ahead of schedule and exceeded all expectations. Highly recommended!',
  },
  {
    id: 3,
    name: 'Emily Rodriguez',
    role: 'Founder',
    company: 'StartupHub',
    avatar: 'https://i.pravatar.cc/150?img=5',
    quote: 'His attention to detail and commitment to quality made all the difference. A true professional.',
  },
  {
    id: 4,
    name: 'David Williams',
    role: 'Lead Developer',
    company: 'CodeMasters',
    avatar: 'https://i.pravatar.cc/150?img=12',
    quote: 'Shehan is an outstanding developer with great communication skills. He turned our complex requirements into elegant solutions.',
  },
  {
    id: 5,
    name: 'Jessica Brown',
    role: 'CEO',
    company: 'Digital Ventures',
    avatar: 'https://i.pravatar.cc/150?img=9',
    quote: 'Impressed by his ability to understand business needs and translate them into functional software. Will definitely work with him again!',
  },
  {
    id: 6,
    name: 'Alex Kumar',
    role: 'Tech Lead',
    company: 'WebSolutions Inc',
    avatar: 'https://i.pravatar.cc/150?img=14',
    quote: 'Creative problem solver with excellent coding standards. Shehan brought fresh ideas and innovative solutions to our team.',
  },
]